import { Link } from 'react-router-dom';
import { useGetCatalogQuery } from '@platform/state/api';
import { useLabel } from '@platform/hooks/useLabel';
import { ModuleTile } from '@platform/ui';
import { cx } from '@platform/core/lib/cx';
import { formatDate } from '@platform/core/lib/format';
import { routes } from '@platform/core/lib/routes';
import { recordNumber } from '@platform/engine/views/recordNumber';
import { useRecordTypeLabels } from '@platform/features/search/useRecordTypeLabels';
import { moduleNav } from '@platform/navigation';
import { useAppSelector } from '@platform/state/hooks';
import { selectLang } from '@platform/state/selectors';
import type { IAreaRecordRowProps } from './IAreaRecordRowProps';

/** Рядок огляду напряму (прототип v4 G:L1890): плитка модуля 22px, номер (голий), назва 500, крапка й підпис статусу, термін 600 (прострочений — червоний). */
export function AreaRecordRow({ ws, record, today }: IAreaRecordRowProps) {
  const label = useLabel();
  const lang = useAppSelector(selectLang);
  const { data: catalog } = useGetCatalogQuery({ workspaceId: ws });
  const labels = useRecordTypeLabels(record.module, record.recordType);
  const status = labels.status(record.status);
  const nav = moduleNav(record.module);
  const due = typeof record.values['due'] === 'string' ? record.values['due'].slice(0, 10) : '';
  return (
    <Link className="ar-row" to={routes.record(record.module, record.recordType, record.id)}>
      <ModuleTile icon={nav.icon} tone={nav.tone} size={22} title={label(catalog?.modules.find((m) => m.key === record.module)?.name)} />
      <span className="ar-code" title={record.display}>{recordNumber(record)}</span>
      <span className="ar-title">{record.title || record.display}</span>
      <span className="ar-status"><span className="hv-dot" style={{ background: status.color }} aria-hidden="true" /><span className="hv-ellipsis">{status.label}</span></span>
      <span className={cx('ar-due', !!due && due < today && !record.isClosed && 'is-late')}>{formatDate(due, lang)}</span>
    </Link>
  );
}
